import { render } from "./UniversalMonthPicker.vue?vue&type=template&id=a90c5336"
import script from "./UniversalMonthPicker.vue?vue&type=script&lang=js"
export * from "./UniversalMonthPicker.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__